import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { canadianStatusDropdown } from '../../../appconfig/Settings';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { Tooltip } from 'primereact/tooltip';



interface GeneralInformationSectionProps {
  userData: any;
  errors: any;
  onInputChange: (e: any, name: string) => void;
  maxDate: Date;
  todayAsMaxDate: Date;
  isMarried: boolean;
  handleOtherExpenseChange: (field: string, value: any, index: number) => void;
  handleRemoveOtherExpenses: (index: number) => void;
  handleAddOtherExpenses: () => void;
  handleDependentChildChange: (
    field: string,
    value: any,
    index: number,
  ) => void;
  handleRemoveDependentChild: (index: number) => void;
  handleAddDependentChild: () => void;

  // tax payer self exployed other expenses
  handleEmployedOtherExpenseChange: (
    field: string,
    value: any,
    index: number,
  ) => void;
  handleRemoveEmployedOtherExpenses: (index: number) => void;
  handleAddEmployedOtherExpenses: () => void;

  // tax payer wfh other expenses
  handleWFHEmployedOtherExpenseChange: (
    field: string,
    value: any,
    index: number,
  ) => void;
  handleRemoveWFHEmployedOtherExpenses: (index: number) => void;
  handleAddWFHEmployedOtherExpenses: () => void;

  // spouse self employed other expense
  handleSpouseEmployedOtherExpenseChange: (
    field: string,
    value: any,
    index: number,
  ) => void;
  handleRemoveSpouseEmployedOtherExpenses: (index: number) => void;
  handleAddSpouseEmployedOtherExpenses: () => void;

  // spouse wfh other expenses
  handleSpouseWFHEmployedOtherExpenseChange: (
    field: string,
    value: any,
    index: number,
  ) => void;
  handleRemoveSpousespouseWfhEmployedOtherExpenses: (index: number) => void;
  handleAddSpousespouseWfhEmployedOtherExpenses: () => void;
}


const GeneralInformationSection: React.FC<GeneralInformationSectionProps> = ({
  userData,
  errors,
  onInputChange,
  maxDate,
  todayAsMaxDate,
  isMarried,
  handleOtherExpenseChange,
  handleRemoveOtherExpenses,
  handleAddOtherExpenses,
  handleDependentChildChange,
  handleRemoveDependentChild,
  handleAddDependentChild,
  handleEmployedOtherExpenseChange,
  handleRemoveEmployedOtherExpenses,
  handleAddEmployedOtherExpenses,
  handleWFHEmployedOtherExpenseChange,
  handleRemoveWFHEmployedOtherExpenses,
  handleAddWFHEmployedOtherExpenses,
  handleSpouseEmployedOtherExpenseChange,
  handleRemoveSpouseEmployedOtherExpenses,
  handleAddSpouseEmployedOtherExpenses,
  handleSpouseWFHEmployedOtherExpenseChange,
  handleRemoveSpousespouseWfhEmployedOtherExpenses,
  handleAddSpousespouseWfhEmployedOtherExpenses,
}) => {
  // State for note text is no longer needed here as it's part of the main formData flow



  return (
    <div className="form-section mb-0">
      <div className="section-title">
        <i className="pi pi-credit-card"></i>
        <h3>Other Income Information</h3>
      </div>

      <div className="grid p-fluid formgrid form-max-heigth">
        {/* First Time Home Buyer ? */}
        <div className="field col-12 md:col-4">
          <label htmlFor="first_time_home_buyer">First time home buyer? </label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="first_time_home_buyer"
                name="first_time_home_buyer"
                value="1"
                onChange={(e) => onInputChange(e, 'first_time_home_buyer')}
                checked={userData?.first_time_home_buyer === '1'}
              />
              <label htmlFor="married_yes" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="first_time_home_buyer"
                name="first_time_home_buyer"
                value="0"
                onChange={(e) => onInputChange(e, 'first_time_home_buyer')}
                checked={userData?.first_time_home_buyer === '0'}
              />
              <label htmlFor="married_no" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">
            {errors['first_time_home_buyer']}
          </small>
        </div>
        {/* Sell Property ? */}
        <div className="field col-12 md:col-4">
          <label htmlFor="property_sell">
            Have you sell any property in current tax year?{' '}
          </label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="property_sell"
                name="property_sell"
                value="1"
                onChange={(e) => onInputChange(e, 'property_sell')}
                checked={userData?.property_sell === '1'}
              />
              <label htmlFor="married_yes" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="property_sell"
                name="property_sell"
                value="0"
                onChange={(e) => onInputChange(e, 'property_sell')}
                checked={userData?.property_sell === '0'}
              />
              <label htmlFor="married_no" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">{errors['property_sell']}</small>
        </div>
        {/* Foreign Property More Than 1 Lakh $ */}
        <div className="field col-12 md:col-4">
          <label htmlFor="property_more_than_1_lakh">
            Do you have foreign property more than 1 lakh $?
          </label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="property_more_than_1_lakh"
                name="property_more_than_1_lakh"
                value="1"
                onChange={(e) => onInputChange(e, 'property_more_than_1_lakh')}
                checked={userData?.property_more_than_1_lakh === '1'}
              />
              <label htmlFor="resident_yes" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="property_more_than_1_lakh"
                name="property_more_than_1_lakh"
                value="0"
                onChange={(e) => onInputChange(e, 'property_more_than_1_lakh')}
                checked={userData?.property_more_than_1_lakh === '0'}
              />
              <label htmlFor="resident_no" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">
            {errors['property_more_than_1_lakh']}
          </small>
        </div>
        <div className="field col-12 md:col-4">
          <label htmlFor="northern_resident_benefit">
            Is eligible for northern resident benefit?
          </label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="northern_resident_benefit"
                name="northern_resident_benefit"
                value="1"
                onChange={(e) => onInputChange(e, 'northern_resident_benefit')}
                checked={userData?.northern_resident_benefit === '1'}
              />
              <label htmlFor="resident_yes" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="northern_resident_benefit"
                name="northern_resident_benefit"
                value="0"
                onChange={(e) => onInputChange(e, 'northern_resident_benefit')}
                checked={userData?.northern_resident_benefit === '0'}
              />
              <label htmlFor="resident_no" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">
            {errors['northern_resident_benefit']}
          </small>
        </div>

        {/* Rental Income */}

        {/* Spouse Income from Home */}
        {/* if rental income is === 1 */}

        <div className="field col-12">
          <hr />
          <div className="section-title">
            <i className="pi pi-list"></i>
            <h3>Rental Information</h3>
          </div>
        </div>

        <div className="field col-12 md:col-4">
          <label htmlFor="rental_income">Do you have rental income?</label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="rental_income"
                name="rental_income"
                value="1"
                onChange={(e) => onInputChange(e, 'rental_income')}
                checked={userData?.rental_income === '1'}
              />
              <label htmlFor="resident_yes" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="rental_income"
                name="rental_income"
                value="0"
                onChange={(e) => onInputChange(e, 'rental_income')}
                checked={userData?.rental_income === '0'}
              />
              <label htmlFor="resident_no" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">{errors['rental_income']}</small>
        </div>

        {userData?.rental_income == '1' && (
          <>
            {/* Rental income */}
            <div className="field col-12 md:col-4">
              <label htmlFor="rental_amount">
                Enter Your Income From Rental Property
              </label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.rental_amount}
                  onChange={(e) => onInputChange(e, 'rental_amount')}
                  placeholder="Enter Rental Amount"
                  className={errors['rental_amount'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['rental_amount']}</small>
            </div>

            {/* Address of property */}
            <div className="field col-12 md:col-4">
              <label htmlFor="property_address">
                Address of The Property <span className="required"></span>
              </label>
              <InputTextarea
                rows={2}
                value={userData.property_address || ''}
                name="property_address"
                placeholder="Enter address of property"
                onChange={(e) => onInputChange(e, 'property_address')}
                className={errors['property_address'] && 'p-invalid'}
              />
              <small className="p-invalid-txt">
                {errors['property_address']}
              </small>
            </div>

            {/* Name of property owner */}
            <div className="field col-12 md:col-4">
              <label htmlFor="name">
                Name of Property Owner <span className="required"></span>
              </label>
              <InputText
                value={`${userData?.first_name} ${userData?.last_name}` || ''}
                name="property_owner_name"
                disabled={true}
                onChange={(e) => onInputChange(e, 'property_owner_name')}
                className={`modern-input ${errors['property_owner_name'] && 'p-invalid'
                  }`}
                placeholder="Enter Property Owner Name"
              />
              <small className="p-invalid-txt">
                {errors['property_owner_name']}
              </small>
            </div>

            {/* share of property owner */}
            <div className="field col-12 md:col-4">
              <label htmlFor="share_of_property_owner">
                Share of Property Owner (in %)
              </label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <InputNumber
                  value={userData.share_of_property_owner ?? null}
                  onChange={(e) => onInputChange(e, 'share_of_property_owner')}
                  placeholder="Enter Share"
                  className={errors['share_of_property_owner'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={0}
                  max={100}
                />
                <span className="font-bold p-inputgroup-addon">%</span>
              </div>
              <small className="p-invalid-txt">
                {errors['share_of_property_owner']}
              </small>
            </div>

            {/* Expenses field */}

            <div className="field col-12">
              <h5 className="mb-0 mt-2">Expenses</h5>
            </div>

            {/* Hydro bill */}
            <div className="field col-12 md:col-4">
              <label htmlFor="rental_amount">BC Hydro Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.bc_hydro_bill || ''}
                  onChange={(e) => onInputChange(e, 'bc_hydro_bill')}
                  placeholder="Enter bc hydro bill"
                  className={errors['bc_hydro_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['bc_hydro_bill']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="utilities">Utilities Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.utilities || ''}
                  onChange={(e) => onInputChange(e, 'utilities')}
                  placeholder="Enter utilities bill"
                  className={errors['utilities'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['utilities']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="repairs">Repairs Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.repairs || ''}
                  onChange={(e) => onInputChange(e, 'repairs')}
                  placeholder="Enter repaires bill"
                  className={errors['repairs'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['repairs']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="bank_interest">Bank Interest Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.bank_interest || ''}
                  onChange={(e) => onInputChange(e, 'bank_interest')}
                  placeholder="Enter interest bill"
                  className={errors['bank_interest'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['bank_interest']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="property_tax">Property Tax Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.property_tax || ''}
                  onChange={(e) => onInputChange(e, 'property_tax')}
                  placeholder="Enter property bill"
                  className={errors['property_tax'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['property_tax']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="insurance">Insurance Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.insurance || ''}
                  onChange={(e) => onInputChange(e, 'insurance')}
                  placeholder="Enter insurance bill"
                  className={errors['insurance'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['insurance']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="insurance">Internet Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.internet || ''}
                  onChange={(e) => onInputChange(e, 'internet')}
                  placeholder="Enter internet bill"
                  className={errors['internet'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['internet']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="fortis_bc">BC Fortis Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.fortis_bc || ''}
                  onChange={(e) => onInputChange(e, 'fortis_bc')}
                  placeholder="Enter fortis bill"
                  className={errors['fortis_bc'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['fortis_bc']}</small>
            </div>

            <div className="field col-12">
              <h5 className="mb-0 mt-2"> Other Expenses</h5>
            </div>

            <>
              {/* Other Expense Names */}
              <div className="field col-12 md:col-12">
                {(userData.generalOtherExpenses?.length
                  ? userData.generalOtherExpenses
                  : [{ name: '', amount: '' }]
                )?.map((otherExpenses: any, index: number) => (
                  <div key={index} className="formgrid grid mb-2">
                    {/* Name Field */}
                    <div className="field col-12 md:col-4">
                      <label>
                        Expense Name {index + 1}
                        <span className="required"></span>
                      </label>
                      <InputText
                        value={otherExpenses?.name}
                        onChange={(e) =>
                          handleOtherExpenseChange(
                            'name',
                            e.target.value,
                            index,
                          )
                        }
                        placeholder={`Expense Name ${index + 1}`}
                        className={
                          errors.generalOtherExpenses?.[index]?.name
                            ? 'p-invalid'
                            : ''
                        }
                      />

                      {errors.generalOtherExpenses?.[index]?.name && (
                        <small className="p-invalid-txt">
                          {errors.generalOtherExpenses[index].name}
                        </small>
                      )}
                    </div>

                    {/* Amount Field */}
                    <div className="field col-12 md:col-4">
                      <label>
                        Amount <span className="required"></span>
                      </label>
                      <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">$</span>
                        <InputNumber
                          value={otherExpenses.amount}
                          onChange={(e) =>
                            handleOtherExpenseChange('amount', e.value, index)
                          }
                          placeholder="Enter Amount"
                          className={
                            errors.generalOtherExpenses?.[index]?.amount
                              ? 'p-invalid'
                              : ''
                          }
                          maxFractionDigits={2}
                          minFractionDigits={2}
                          mode="decimal"
                        />
                      </div>
                      {errors.generalOtherExpenses?.[index]?.amount && (
                        <small className="p-invalid-txt">
                          {errors.generalOtherExpenses[index].amount}
                        </small>
                      )}
                    </div>

                    {/* Remove Button */}
                    <div className="col-12 md:col-1 flex align-items-center mt-2">
                      {index > 0 && (
                        <Button
                          icon="pi pi-trash"
                          className="p-button-danger p-button-rounded p-button-sm"
                          onClick={() => handleRemoveOtherExpenses(index)}
                        />
                      )}
                    </div>
                  </div>
                ))}

                <Button
                  label="Add Expense"
                  icon="pi pi-plus"
                  className="p-button mt-2 add-more-btn"
                  style={{ width: 'auto' }}
                  onClick={handleAddOtherExpenses}
                />
              </div>
            </>
          </>
        )}

        {/* ....................................... Tax payer self employed expenses field ................................  */}

        {/* Self Employed Expenses field */}
        <div className="field col-12">
          <hr />
          <div className="section-title">
            <i className="pi pi-user"></i>
            <h3>Self Employed Information</h3>
          </div>
        </div>

        {/* Do you have self employed income */}
        <div className="field col-12 md:col-4">
          <label htmlFor="self_employed_income">
            Do you have self employed income?{' '}
          </label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="self_employed_income"
                name="self_employed_income"
                value="1"
                onChange={(e) => onInputChange(e, 'self_employed_income')}
                checked={userData?.self_employed_income === '1'}
              />
              <label htmlFor="married_yes" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="self_employed_income"
                name="self_employed_income"
                value="0"
                onChange={(e) => onInputChange(e, 'self_employed_income')}
                checked={userData?.self_employed_income === '0'}
              />
              <label htmlFor="married_no" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">
            {errors['self_employed_income']}
          </small>
        </div>

        {userData?.self_employed_income == '1' && (
          <div className="field col-12 md:col-4">
            <label htmlFor="self_employed_amount">Self Employed Income</label>
            <span className="required">*</span>
            <div className="flex-1 input-effect-div p-inputgroup">
              <span className="font-bold p-inputgroup-addon">$</span>
              <InputNumber
                value={userData.self_employed_amount}
                onChange={(e) => onInputChange(e, 'self_employed_amount')}
                placeholder="Enter self employed income"
                className={errors['self_employed_amount'] && 'p-invalid'}
                minFractionDigits={2}
                maxFractionDigits={2}
                mode="decimal"
              />
            </div>
            <small className="p-invalid-txt">
              {errors['self_employed_amount']}
            </small>
          </div>
        )}

        {userData?.self_employed_income == '1' && (
          <>
            {/* Do you have a gst number */}
            <div className="field col-12 md:col-4">
              <label htmlFor="has_gst">Do you have a gst number? </label>
              <span className="required"> *</span>
              <div className="flex gap-4 mt-2">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="has_gst"
                    name="has_gst"
                    value="1"
                    onChange={(e) => onInputChange(e, 'has_gst')}
                    checked={userData?.has_gst === '1'}
                  />
                  <label htmlFor="married_yes" className="ml-2">
                    Yes
                  </label>
                </div>
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="has_gst"
                    name="has_gst"
                    value="0"
                    onChange={(e) => onInputChange(e, 'has_gst')}
                    checked={userData?.has_gst === '0'}
                  />
                  <label htmlFor="married_no" className="ml-2">
                    No
                  </label>
                </div>
              </div>
              <small className="p-invalid-txt">{errors['has_gst']}</small>
            </div>

            {/* Enter Gst no */}

            {userData?.has_gst === '1' && (
              <div className="field col-12 md:col-4">
                <label htmlFor="gst_no">
                  GST Number <span className="required">*</span>
                </label>
                <InputText
                  value={userData?.gst_no || ''}
                  name="gst_no"
                  onChange={(e) => onInputChange(e, 'gst_no')}
                  className={errors['gst_no'] && 'p-invalid'}
                  placeholder="Enter GST Number"
                  keyfilter="pint"
                />
                <small className="p-invalid-txt">{errors['gst_no']}</small>
              </div>
            )}

            <div className="field col-12">
              <h5 className="mb-0 mt-2">Self Employed Expenses</h5>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="gas_expense">Gas Expenses</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.gas_expense || ''}
                  onChange={(e) => onInputChange(e, 'gas_expense')}
                  placeholder="Enter gas expense"
                  className={errors['gas_expense'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['gas_expense']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="repairs_expense">Repairs Expenses</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.repairs_expense || ''}
                  onChange={(e) => onInputChange(e, 'repairs_expense')}
                  placeholder="Enter repaires expense"
                  className={errors['repairs_expense'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['repairs_expense']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="insurance_expense">Insurance Expenses</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.insurance_expense || ''}
                  onChange={(e) => onInputChange(e, 'insurance_expense')}
                  placeholder="Enter insurance expense"
                  className={errors['insurance_expense'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['insurance_expense']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="phone_bill_expenses">Phone Bill Expenses</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.phone_bill_expenses || ''}
                  onChange={(e) => onInputChange(e, 'phone_bill_expenses')}
                  placeholder="Enter phone bill expense "
                  className={errors['phone_bill_expenses'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['phone_bill_expenses']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="meal_expenses">Meal Expenses</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.meal_expenses || ''}
                  onChange={(e) => onInputChange(e, 'meal_expenses')}
                  placeholder="Enter meal expenses"
                  className={errors['meal_expenses'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['meal_expenses']}</small>
            </div>
            <div className="field md:col-4"></div>

            <div className="field col-12 md:col-4">
              <label htmlFor="name">
                Car Model <span className=""></span>
              </label>
              <InputText
                value={userData.car_model || ''}
                name="car_model"
                onChange={(e) => onInputChange(e, 'car_model')}
                className={`modern-input ${errors['car_model'] && 'p-invalid'}`}
                placeholder="Enter car model "
              />
              <small className="p-invalid-txt">{errors['car_model']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="name">
                Model Year <span className=""></span>
              </label>
              <InputText
                value={userData.car_model_year || ''}
                name="car_model_year"
                onChange={(e) => onInputChange(e, 'car_model_year')}
                className={`modern-input ${errors['car_model_year'] && 'p-invalid'
                  }`}
                placeholder="Enter model year"
              />
              <small className="p-invalid-txt">
                {errors['car_model_year']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="name">
                Purchase Year <span className=""></span>
              </label>
              <InputText
                value={userData.car_purchase_year || ''}
                name="car_purchase_year"
                onChange={(e) => onInputChange(e, 'car_purchase_year')}
                className={`modern-input ${errors['car_purchase_year'] && 'p-invalid'
                  }`}
                placeholder="Enter purchase year"
              />
              <small className="p-invalid-txt">
                {errors['car_purchase_year']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="insurance">Car purchase price</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.car_price_paid || ''}
                  onChange={(e) => onInputChange(e, 'car_price_paid')}
                  placeholder="Enter car purchase price"
                  className={errors['car_price_paid'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['car_price_paid']}
              </small>
            </div>

            <div className="field col-12">
              <h5 className="mb-0 mt-3">Self Employed Other Expenses</h5>
            </div>

            <>
              {/* Self Employed Other Expense Names */}
              <div className="field col-12 md:col-12">
                {(userData.employedOtherExpenses?.length
                  ? userData.employedOtherExpenses
                  : [{ name: '', amount: '' }]
                )?.map((otherExpenses: any, index: number) => (
                  <div key={index} className="formgrid grid mb-2">
                    {/* Name Field */}
                    <div className="field col-12 md:col-4">
                      <label>
                        Employed Expense Name {index + 1}
                        <span className="required"></span>
                      </label>
                      <InputText
                        value={otherExpenses?.name}
                        onChange={(e) =>
                          handleEmployedOtherExpenseChange(
                            'name',
                            e.target.value,
                            index,
                          )
                        }
                        placeholder={`Employed Expense Name ${index + 1}`}
                        className={
                          errors.employedOtherExpenses?.[index]?.name
                            ? 'p-invalid'
                            : ''
                        }
                      />

                      {errors.employedOtherExpenses?.[index]?.name && (
                        <small className="p-invalid-txt">
                          {errors.employedOtherExpenses[index].name}
                        </small>
                      )}
                    </div>

                    {/* Amount Field */}
                    <div className="field col-12 md:col-4">
                      <label>
                        Amount <span className="required"></span>
                      </label>
                      <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">$</span>
                        <InputNumber
                          value={otherExpenses.amount}
                          onChange={(e) =>
                            handleEmployedOtherExpenseChange(
                              'amount',
                              e.value,
                              index,
                            )
                          }
                          placeholder="Enter Amount"
                          className={
                            errors.employedOtherExpenses?.[index]?.amount
                              ? 'p-invalid'
                              : ''
                          }
                          maxFractionDigits={2}
                          minFractionDigits={2}
                          mode="decimal"
                        />
                      </div>
                      {errors.employedOtherExpenses?.[index]?.amount && (
                        <small className="p-invalid-txt">
                          {errors.employedOtherExpenses[index].amount}
                        </small>
                      )}
                    </div>

                    {/* Remove Button */}
                    <div className="col-12 md:col-1 flex align-items-center mt-2">
                      {index > 0 && (
                        <Button
                          icon="pi pi-trash"
                          className="p-button-danger p-button-rounded p-button-sm"
                          onClick={() =>
                            handleRemoveEmployedOtherExpenses(index)
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}

                <Button
                  label="Add Self Employed Expense"
                  icon="pi pi-plus"
                  className="p-button mt-2 add-more-btn"
                  style={{ width: 'auto' }}
                  onClick={handleAddEmployedOtherExpenses}
                />
              </div>
            </>
          </>
        )}

        {/* ...................................... spouse self employed expenses field ...............................  */}

        {userData?.is_spouse_canadian_resident == '1' && (
          <>
            {/* Self Employed Expenses field */}
            <div className="field col-12">
              <hr />
              <div className="section-title">
                <i className="pi pi-user"></i>
                <h3>Spouse Self Employed Information</h3>
              </div>
            </div>

            {/* Do you have self employed income */}
            <div className="field col-12 md:col-4">
              <label htmlFor="spouse_self_employed_income">
                Do spouse have self employed income?{' '}
              </label>
              <span className="required"> *</span>
              <div className="flex gap-4 mt-2">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="spouse_self_employed_income"
                    name="spouse_self_employed_income"
                    value="1"
                    onChange={(e) =>
                      onInputChange(e, 'spouse_self_employed_income')
                    }
                    checked={userData?.spouse_self_employed_income === '1'}
                  />
                  <label htmlFor="married_yes" className="ml-2">
                    Yes
                  </label>
                </div>
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="spouse_self_employed_income"
                    name="spouse_self_employed_income"
                    value="0"
                    onChange={(e) =>
                      onInputChange(e, 'spouse_self_employed_income')
                    }
                    checked={userData?.spouse_self_employed_income === '0'}
                  />
                  <label htmlFor="married_no" className="ml-2">
                    No
                  </label>
                </div>
              </div>
              <small className="p-invalid-txt">
                {errors['spouse_self_employed_income']}
              </small>
            </div>

            {userData?.spouse_self_employed_income == '1' && (
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_self_employed_amount">
                  Spouse Self Employed Income
                </label>
                <span className="required">*</span>
                <div className="flex-1 input-effect-div p-inputgroup">
                  <span className="font-bold p-inputgroup-addon">$</span>
                  <InputNumber
                    value={userData.spouse_self_employed_amount}
                    onChange={(e) =>
                      onInputChange(e, 'spouse_self_employed_amount')
                    }
                    placeholder="Enter spouse self employed income"
                    className={
                      errors['spouse_self_employed_amount'] && 'p-invalid'
                    }
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    mode="decimal"
                  />
                </div>
                <small className="p-invalid-txt">
                  {errors['spouse_self_employed_amount']}
                </small>
              </div>
            )}

            {userData?.spouse_self_employed_income == '1' && (
              <>
                {/* Do you have a gst number */}
                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_has_gst">
                    Do spouse have a gst number?{' '}
                  </label>
                  <span className="required"> *</span>
                  <div className="flex gap-4 mt-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="spouse_has_gst"
                        name="spouse_has_gst"
                        value="1"
                        onChange={(e) => onInputChange(e, 'spouse_has_gst')}
                        checked={userData?.spouse_has_gst === '1'}
                      />
                      <label htmlFor="married_yes" className="ml-2">
                        Yes
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="spouse_has_gst"
                        name="spouse_has_gst"
                        value="0"
                        onChange={(e) => onInputChange(e, 'spouse_has_gst')}
                        checked={userData?.spouse_has_gst === '0'}
                      />
                      <label htmlFor="married_no" className="ml-2">
                        No
                      </label>
                    </div>
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_has_gst']}
                  </small>
                </div>

                {/* Enter Gst no */}
                {userData?.spouse_has_gst === '1' && (
                  <div className="field col-12 md:col-4">
                    <label htmlFor="spouse_gst_no">
                      GST Number <span className="required">*</span>
                    </label>
                    <InputText
                      value={userData?.spouse_gst_no || ''}
                      name="spouse_gst_no"
                      onChange={(e) => onInputChange(e, 'spouse_gst_no')}
                      className={errors['spouse_gst_no'] && 'p-invalid'}
                      placeholder="Enter GST Number"
                      keyfilter="pint"
                    />
                    <small className="p-invalid-txt">
                      {errors['spouse_gst_no']}
                    </small>
                  </div>
                )}

                <div className="field col-12">
                  <h5 className="mb-0 mt-2">Spouse Self Employed Expenses</h5>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_gas_expense">Gas Expenses</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_gas_expense || ''}
                      onChange={(e) => onInputChange(e, 'spouse_gas_expense')}
                      placeholder="Enter gas expense"
                      className={errors['spouse_gas_expense'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_gas_expense']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_repairs_expense">
                    Repairs Expenses
                  </label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_repairs_expense || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_repairs_expense')
                      }
                      placeholder="Enter repaires expense"
                      className={
                        errors['spouse_repairs_expense'] && 'p-invalid'
                      }
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_repairs_expense']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_insurance_expense">
                    Insurance Expenses
                  </label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_insurance_expense || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_insurance_expense')
                      }
                      placeholder="Enter insurance expense"
                      className={
                        errors['spouse_insurance_expense'] && 'p-invalid'
                      }
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_insurance_expense']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_phone_bill_expenses">
                    Phone Bill Expenses
                  </label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_phone_bill_expenses || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_phone_bill_expenses')
                      }
                      placeholder="Enter phone bill expense "
                      className={
                        errors['spouse_phone_bill_expenses'] && 'p-invalid'
                      }
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_phone_bill_expenses']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_meal_expenses">Meal Expenses</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_meal_expenses || ''}
                      onChange={(e) => onInputChange(e, 'spouse_meal_expenses')}
                      placeholder="Enter meal expenses"
                      className={errors['spouse_meal_expenses'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_meal_expenses']}
                  </small>
                </div>
                <div className="field md:col-4"></div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="name">
                    Car Model <span className=""></span>
                  </label>
                  <InputText
                    value={userData.spouse_car_model || ''}
                    name="spouse_car_model"
                    onChange={(e) => onInputChange(e, 'spouse_car_model')}
                    className={`modern-input ${errors['spouse_car_model'] && 'p-invalid'
                      }`}
                    placeholder="Enter car model "
                  />
                  <small className="p-invalid-txt">
                    {errors['spouse_car_model']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="name">
                    Model Year <span className=""></span>
                  </label>
                  <InputText
                    value={userData.spouse_car_model_year || ''}
                    name="spouse_car_model_year"
                    onChange={(e) => onInputChange(e, 'spouse_car_model_year')}
                    className={`modern-input ${errors['spouse_car_model_year'] && 'p-invalid'
                      }`}
                    placeholder="Enter model year"
                  />
                  <small className="p-invalid-txt">
                    {errors['spouse_car_model_year']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="name">
                    Purchase Year <span className=""></span>
                  </label>
                  <InputText
                    value={userData.spouse_car_purchase_year || ''}
                    name="spouse_car_purchase_year"
                    onChange={(e) =>
                      onInputChange(e, 'spouse_car_purchase_year')
                    }
                    className={`modern-input ${errors['spouse_car_purchase_year'] && 'p-invalid'
                      }`}
                    placeholder="Enter purchase year"
                  />
                  <small className="p-invalid-txt">
                    {errors['spouse_car_purchase_year']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="insurance">Car purchase price</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_car_price_paid || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_car_price_paid')
                      }
                      placeholder="Enter car purchase price"
                      className={errors['spouse_car_price_paid'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_car_price_paid']}
                  </small>
                </div>

                <div className="field col-12">
                  <h5 className="mb-0 mt-3">
                    Spouse Self Employed Other Expenses
                  </h5>
                </div>

                <>
                  {/* Self Employed Other Expense Names */}
                  <div className="field col-12 md:col-12">
                    {(userData.spouseEmployedOtherExpenses?.length
                      ? userData.spouseEmployedOtherExpenses
                      : [{ name: '', amount: '' }]
                    )?.map((otherExpenses: any, index: number) => (
                      <div key={index} className="formgrid grid mb-2">
                        {/* Name Field */}
                        <div className="field col-12 md:col-4">
                          <label>
                            Employed Expense Name {index + 1}
                            <span className="required"></span>
                          </label>
                          <InputText
                            value={otherExpenses?.name}
                            onChange={(e) =>
                              handleSpouseEmployedOtherExpenseChange(
                                'name',
                                e.target.value,
                                index,
                              )
                            }
                            placeholder={`Employed Expense Name ${index + 1}`}
                            className={
                              errors.spouseEmployedOtherExpenses?.[index]?.name
                                ? 'p-invalid'
                                : ''
                            }
                          />

                          {errors.spouseEmployedOtherExpenses?.[index]
                            ?.name && (
                              <small className="p-invalid-txt">
                                {errors.spouseEmployedOtherExpenses[index].name}
                              </small>
                            )}
                        </div>

                        {/* Amount Field */}
                        <div className="field col-12 md:col-4">
                          <label>
                            Amount <span className="required"></span>
                          </label>
                          <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">$</span>
                            <InputNumber
                              value={otherExpenses.amount}
                              onChange={(e) =>
                                handleSpouseEmployedOtherExpenseChange(
                                  'amount',
                                  e.value,
                                  index,
                                )
                              }
                              placeholder="Enter Amount"
                              className={
                                errors.spouseEmployedOtherExpenses?.[index]
                                  ?.amount
                                  ? 'p-invalid'
                                  : ''
                              }
                              maxFractionDigits={2}
                              minFractionDigits={2}
                              mode="decimal"
                            />
                          </div>
                          {errors.spouseEmployedOtherExpenses?.[index]
                            ?.amount && (
                              <small className="p-invalid-txt">
                                {errors.spouseEmployedOtherExpenses[index].amount}
                              </small>
                            )}
                        </div>

                        {/* Remove Button */}
                        <div className="col-12 md:col-1 flex align-items-center mt-2">
                          {index > 0 && (
                            <Button
                              icon="pi pi-trash"
                              className="p-button-danger p-button-rounded p-button-sm"
                              onClick={() =>
                                handleRemoveSpouseEmployedOtherExpenses(index)
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}

                    <Button
                      label="Add Spouse Self Employed Expense"
                      icon="pi pi-plus"
                      className="p-button mt-2 add-more-btn"
                      style={{ width: 'auto' }}
                      onClick={handleAddSpouseEmployedOtherExpenses}
                    />
                  </div>
                </>
              </>
            )}
          </>
        )}

        {/* ..................................................... work from home expenses ...............................  */}

        {/* Self Employed Expenses field */}

        <div className="field col-12">
          <hr />
          <div className="section-title">
            <i className="pi pi-home"></i>
            <h3>Work From Home Employed Information</h3>
          </div>
        </div>

        <div className="field col-12 md:col-4">
          <label htmlFor="long_haul_truck_driver">Are you long haul truck driver ? </label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="long_haul_truck_driver"
                name="long_haul_truck_driver"
                value="1"
                onChange={(e) => onInputChange(e, 'long_haul_truck_driver')}
                checked={userData?.long_haul_truck_driver === '1'}
              />
              <label htmlFor="long_haul_truck_driver" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="long_haul_truck_driver"
                name="long_haul_truck_driver"
                value="0"
                onChange={(e) => onInputChange(e, 'long_haul_truck_driver')}
                checked={userData?.long_haul_truck_driver === '0'}
              />
              <label htmlFor="long_haul_truck_driver" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">{errors['long_haul_truck_driver']}</small>
        </div>

        {/*Do you work from home */}
        <div className="field col-12 md:col-4">
          <label htmlFor="work_from_home">Do you work from home ? </label>
          <span className="required"> *</span>
          <div className="flex gap-4 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="work_from_home"
                name="work_from_home"
                value="1"
                onChange={(e) => onInputChange(e, 'work_from_home')}
                checked={userData?.work_from_home === '1'}
              />
              <label htmlFor="married_yes" className="ml-2">
                Yes
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="work_from_home"
                name="work_from_home"
                value="0"
                onChange={(e) => onInputChange(e, 'work_from_home')}
                checked={userData?.work_from_home === '0'}
              />
              <label htmlFor="married_no" className="ml-2">
                No
              </label>
            </div>
          </div>
          <small className="p-invalid-txt">{errors['work_from_home']}</small>
        </div>

        {/* Do your employer allow you to claim expenses for work from home*/}
        {userData?.work_from_home == '1' && (
          <>
            <div className="col-12 md:col-4">
              <label htmlFor="claim_expense">
                Do your employer allow you to claim expenses for work from home?{' '}
              </label>
              <span className="required"> *</span>
              <div className="flex gap-4 mt-2">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="claim_expense"
                    name="claim_expense"
                    value="1"
                    onChange={(e) => onInputChange(e, 'claim_expense')}
                    checked={userData?.claim_expense === '1'}
                  />
                  <label htmlFor="married_yes" className="ml-2">
                    Yes
                  </label>
                </div>
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="claim_expense"
                    name="claim_expense"
                    value="0"
                    onChange={(e) => onInputChange(e, 'claim_expense')}
                    checked={userData?.claim_expense === '0'}
                  />
                  <label htmlFor="married_no" className="ml-2">
                    No
                  </label>
                </div>
              </div>
              <small className="p-invalid-txt">{errors['claim_expense']}</small>
            </div>

            <div className="field col-12">
              <h5 className="mb-0 mt-3">WFH Employed Expenses</h5>
            </div>

            {/* Internet bill */}
            <div className="field col-12 md:col-4">
              <label htmlFor="internet_bill">Internet Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.internet_bill || ''}
                  onChange={(e) => onInputChange(e, 'internet_bill')}
                  placeholder="Enter internet bill"
                  className={errors['internet_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['internet_bill']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="insurance_bill">Insurance Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.insurance_bill || ''}
                  onChange={(e) => onInputChange(e, 'insurance_bill')}
                  placeholder="Enter insurance bill"
                  className={errors['insurance_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['insurance_bill']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="equipment_bill">Equipment Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.equipment_bill || ''}
                  onChange={(e) => onInputChange(e, 'equipment_bill')}
                  placeholder="Enter equipement bill"
                  className={errors['equipment_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['equipment_bill']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="stationery_bill">Stationery Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.stationery_bill || ''}
                  onChange={(e) => onInputChange(e, 'stationery_bill')}
                  placeholder="Enter stationery bill "
                  className={errors['stationery_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['stationery_bill']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="utilities_bill">Utilities Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.utilities_bill || ''}
                  onChange={(e) => onInputChange(e, 'utilities_bill')}
                  placeholder="Enter utilities bill"
                  className={errors['utilities_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">
                {errors['utilities_bill']}
              </small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="hydro_bill">Hydro Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.hydro_bill || ''}
                  onChange={(e) => onInputChange(e, 'hydro_bill')}
                  placeholder="Enter hydro bill"
                  className={errors['hydro_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['hydro_bill']}</small>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="rent_bill">Rent Bill</label>
              <span className="required"></span>
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={userData.rent_bill || ''}
                  onChange={(e) => onInputChange(e, 'rent_bill')}
                  placeholder="Enter rent bill"
                  className={errors['rent_bill'] && 'p-invalid'}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                />
              </div>
              <small className="p-invalid-txt">{errors['rent_bill']}</small>
            </div>

            <div className="field col-12">
              <h5 className="mb-0 mt-3">
                Work From Home Employed Other Expenses
              </h5>
            </div>

            <>
              {/* Wfh  Employed Other Expense Names */}
              <div className="field col-12 md:col-12">
                {(userData.wfhEmployedOtherExpenses?.length
                  ? userData.wfhEmployedOtherExpenses
                  : [{ name: '', amount: '' }]
                )?.map((otherExpenses: any, index: number) => (
                  <div key={index} className="formgrid grid mb-2">
                    {/* Name Field */}
                    <div className="field col-12 md:col-4">
                      <label>
                        WFH Employed Expense Name {index + 1}
                        <span className="required"></span>
                      </label>
                      <InputText
                        value={otherExpenses?.name}
                        onChange={(e) =>
                          handleWFHEmployedOtherExpenseChange(
                            'name',
                            e.target.value,
                            index,
                          )
                        }
                        placeholder={`WFH Employed Expense Name ${index + 1}`}
                        className={
                          errors.wfhEmployedOtherExpenses?.[index]?.name
                            ? 'p-invalid'
                            : ''
                        }
                      />

                      {errors.wfhEmployedOtherExpenses?.[index]?.name && (
                        <small className="p-invalid-txt">
                          {errors.wfhEmployedOtherExpenses[index].name}
                        </small>
                      )}
                    </div>

                    {/* Amount Field */}
                    <div className="field col-12 md:col-4">
                      <label>
                        Amount <span className="required"></span>
                      </label>
                      <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">$</span>
                        <InputNumber
                          value={otherExpenses.amount}
                          onChange={(e) =>
                            handleWFHEmployedOtherExpenseChange(
                              'amount',
                              e.value,
                              index,
                            )
                          }
                          placeholder="Enter Amount"
                          className={
                            errors.wfhEmployedOtherExpenses?.[index]?.amount
                              ? 'p-invalid'
                              : ''
                          }
                          maxFractionDigits={2}
                          minFractionDigits={2}
                          mode="decimal"
                        />
                      </div>
                      {errors.wfhEmployedOtherExpenses?.[index]?.amount && (
                        <small className="p-invalid-txt">
                          {errors.wfhEmployedOtherExpenses[index].amount}
                        </small>
                      )}
                    </div>

                    {/* Remove Button */}
                    <div className="col-12 md:col-1 flex align-items-center mt-2">
                      {index > 0 && (
                        <Button
                          icon="pi pi-trash"
                          className="p-button-danger p-button-rounded p-button-sm"
                          onClick={() =>
                            handleRemoveWFHEmployedOtherExpenses(index)
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}

                <Button
                  label="Add WFH Employed Expense"
                  icon="pi pi-plus"
                  className="p-button mt-2 add-more-btn"
                  style={{ width: 'auto' }}
                  onClick={handleAddWFHEmployedOtherExpenses}
                />
              </div>
            </>
          </>
        )}

        {/* ........................................ spouse work from home expenses  ........................  */}

        {userData?.is_spouse_canadian_resident == '1' && (
          <>
            <div className="field col-12">
              <hr />
              <div className="section-title">
                <i className="pi pi-home"></i>
                <h3>Spouse Work From Home Employed Information</h3>
              </div>
            </div>

            {/*Do you work from home */}
            <div className="field col-12 md:col-4">
              <label htmlFor="spouse_work_from_home">
                Do Spouse work from home ?{' '}
              </label>
              <span className="required"> *</span>
              <div className="flex gap-4 mt-2">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="spouse_work_from_home"
                    name="spouse_work_from_home"
                    value="1"
                    onChange={(e) => onInputChange(e, 'spouse_work_from_home')}
                    checked={userData?.spouse_work_from_home === '1'}
                  />
                  <label htmlFor="married_yes" className="ml-2">
                    Yes
                  </label>
                </div>
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="spouse_work_from_home"
                    name="spouse_work_from_home"
                    value="0"
                    onChange={(e) => onInputChange(e, 'spouse_work_from_home')}
                    checked={userData?.spouse_work_from_home === '0'}
                  />
                  <label htmlFor="married_no" className="ml-2">
                    No
                  </label>
                </div>
              </div>
              <small className="p-invalid-txt">
                {errors['spouse_work_from_home']}
              </small>
            </div>

            {/* Do your employer allow you to claim expenses for work from home*/}
            {userData?.spouse_work_from_home == '1' && (
              <>
                <div className="col-12 md:col-4">
                  <label htmlFor="spouse_claim_expense">
                    Do your employer allow you to claim expenses for work from
                    home?{' '}
                  </label>
                  <span className="required"> *</span>
                  <div className="flex gap-4 mt-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="spouse_claim_expense"
                        name="spouse_claim_expense"
                        value="1"
                        onChange={(e) =>
                          onInputChange(e, 'spouse_claim_expense')
                        }
                        checked={userData?.spouse_claim_expense === '1'}
                      />
                      <label htmlFor="married_yes" className="ml-2">
                        Yes
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="spouse_claim_expense"
                        name="spouse_claim_expense"
                        value="0"
                        onChange={(e) =>
                          onInputChange(e, 'spouse_claim_expense')
                        }
                        checked={userData?.spouse_claim_expense === '0'}
                      />
                      <label htmlFor="married_no" className="ml-2">
                        No
                      </label>
                    </div>
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_claim_expense']}
                  </small>
                </div>

                <div className="field col-12">
                  <h5 className="mb-0 mt-3">Spouse WFH Employed Expenses</h5>
                </div>

                {/* Internet bill */}
                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_internet_bill">Internet Bill</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_internet_bill || ''}
                      onChange={(e) => onInputChange(e, 'spouse_internet_bill')}
                      placeholder="Enter internet bill"
                      className={errors['spouse_internet_bill'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_internet_bill']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_insurance_bill">Insurance Bill</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_insurance_bill || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_insurance_bill')
                      }
                      placeholder="Enter insurance bill"
                      className={errors['spouse_insurance_bill'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_insurance_bill']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_equipment_bill">Equipment Bill</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_equipment_bill || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_equipment_bill')
                      }
                      placeholder="Enter equipement bill"
                      className={errors['spouse_equipment_bill'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_equipment_bill']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_stationery_bill">
                    Stationery Bill
                  </label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_stationery_bill || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_stationery_bill')
                      }
                      placeholder="Enter stationery bill "
                      className={
                        errors['spouse_stationery_bill'] && 'p-invalid'
                      }
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_stationery_bill']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_utilities_bill">Utilities Bill</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_utilities_bill || ''}
                      onChange={(e) =>
                        onInputChange(e, 'spouse_utilities_bill')
                      }
                      placeholder="Enter utilities bill"
                      className={errors['spouse_utilities_bill'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_utilities_bill']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_hydro_bill">Hydro Bill</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_hydro_bill || ''}
                      onChange={(e) => onInputChange(e, 'spouse_hydro_bill')}
                      placeholder="Enter hydro bill"
                      className={errors['spouse_hydro_bill'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_hydro_bill']}
                  </small>
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="spouse_rent_bill">Rent Bill</label>
                  <span className="required"></span>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={userData.spouse_rent_bill || ''}
                      onChange={(e) => onInputChange(e, 'spouse_rent_bill')}
                      placeholder="Enter rent bill"
                      className={errors['spouse_rent_bill'] && 'p-invalid'}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_rent_bill']}
                  </small>
                </div>

                <div className="field col-12">
                  <h5 className="mb-0 mt-3">
                    Spouse Work From Home Employed Other Expenses
                  </h5>
                </div>

                <>
                  {/* spouse  Wfh  Employed Other Expense Names */}
                  <div className="field col-12 md:col-12">
                    {(userData.spouseWfhEmployedOtherExpenses?.length
                      ? userData.spouseWfhEmployedOtherExpenses
                      : [{ name: '', amount: '' }]
                    )?.map((otherExpenses: any, index: number) => (
                      <div key={index} className="formgrid grid mb-2">
                        {/* Name Field */}
                        <div className="field col-12 md:col-4">
                          <label>
                            WFH Employed Expense Name {index + 1}
                            <span className="required"></span>
                          </label>
                          <InputText
                            value={otherExpenses?.name}
                            onChange={(e) =>
                              handleSpouseWFHEmployedOtherExpenseChange(
                                'name',
                                e.target.value,
                                index,
                              )
                            }
                            placeholder={`WFH Employed Expense Name ${index + 1
                              }`}
                            className={
                              errors.spouseWfhEmployedOtherExpenses?.[index]
                                ?.name
                                ? 'p-invalid'
                                : ''
                            }
                          />

                          {errors.spouseWfhEmployedOtherExpenses?.[index]
                            ?.name && (
                              <small className="p-invalid-txt">
                                {
                                  errors.spouseWfhEmployedOtherExpenses[index]
                                    .name
                                }
                              </small>
                            )}
                        </div>

                        {/* Amount Field */}
                        <div className="field col-12 md:col-4">
                          <label>
                            Amount <span className="required"></span>
                          </label>
                          <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">$</span>
                            <InputNumber
                              value={otherExpenses.amount}
                              onChange={(e) =>
                                handleSpouseWFHEmployedOtherExpenseChange(
                                  'amount',
                                  e.value,
                                  index,
                                )
                              }
                              placeholder="Enter Amount"
                              className={
                                errors.spouseWfhEmployedOtherExpenses?.[index]
                                  ?.amount
                                  ? 'p-invalid'
                                  : ''
                              }
                              maxFractionDigits={2}
                              minFractionDigits={2}
                              mode="decimal"
                            />
                          </div>
                          {errors.spouseWfhEmployedOtherExpenses?.[index]
                            ?.amount && (
                              <small className="p-invalid-txt">
                                {
                                  errors.spouseWfhEmployedOtherExpenses[index]
                                    .amount
                                }
                              </small>
                            )}
                        </div>

                        {/* Remove Button */}
                        <div className="col-12 md:col-1 flex align-items-center mt-2">
                          {index > 0 && (
                            <Button
                              icon="pi pi-trash"
                              className="p-button-danger p-button-rounded p-button-sm"
                              onClick={() =>
                                handleRemoveSpousespouseWfhEmployedOtherExpenses(
                                  index,
                                )
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}

                    <Button
                      label="Add Spouse WFH Employed Expense"
                      icon="pi pi-plus"
                      className="p-button mt-2 add-more-btn"
                      style={{ width: 'auto' }}
                      onClick={handleAddSpousespouseWfhEmployedOtherExpenses}
                    />
                  </div>
                </>
              </>
            )}
          </>
        )}

        {/* add note  */}
        <div className="field col-12">
          <hr />
          <div className="section-title">
            <i className="pi pi-file"></i>
            <h3>Add Notes</h3>
          </div>
        </div>

        <div className="field col-12">
          <InputTextarea
            value={userData?.form_note || ''}
            onChange={(e) => onInputChange(e, 'form_note')}
            rows={5}
            className="w-full"
            placeholder="Enter your notes here..."
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralInformationSection;
